import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {trans} from '../../helpers/HelperGlobal';
import {Button, Form, Input} from 'antd';
import MaskedInput from 'antd-mask-input';
import HelperGeneral from '../../helpers/HelperGeneral';
import {Col, Container, Row} from 'react-bootstrap';
import Countdown, {zeroPad} from 'react-countdown';
import Api from '../../services/Api';
import {setGlobalSpinner} from '../../services/redux/actions/GeneralAction';
import UserInfo from '../auth/UserInfo';
import LogoScroller from "../partials/LogoScroller";
import {extractAnalyticsUserBinding} from '../../helpers/SoulAnalytics';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            customerType: HelperGeneral.getCustomerTypeFromURL(),
            info: {},
            width: window.innerWidth,
            customerPhoneNumber: undefined,
            date: null
        };

        this.form = React.createRef();
    }

    componentDidMount() {
        if (UserInfo.isLogin()) {
            HelperGeneral.pageChange(this, '/home');
        }

        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (UserInfo.isLogin()) {
            HelperGeneral.pageChange(this, '/home');
        }
    }

    resize = () => this.setState({width: window.innerWidth});

    loginSubmit = (e) => {
        const {step, info, customerPhoneNumber} = this.state;
        setGlobalSpinner(true);

        if (step === 1) {
            const data = {
                'telephone': e?.mobilePhone,
                'password': e?.password,
                'remember': true,
                'token': true
            }

            Api.customerLogin(data).then(response => {
                localStorage.removeItem('orderInfo');
                localStorage.removeItem('basketList');
                localStorage.removeItem('deliveryModalVisibility');

                if (response?.data && response?.data?.info) {
                    const userRolesId = Number(response?.data?.info?.user_roles_id);

                    localStorage.setItem('userInfo', response?.data?.info);
                    localStorage.setItem('userToken', JSON.stringify(response?.data?.token));
                    UserInfo.setUserInfo(response?.data?.info, true);

                    try {
                        const info = response?.data?.info;
                        if (info && info.id) {
                            if (window.SoulAnalytics && typeof window.SoulAnalytics.setUserData === 'function') {
                                window.SoulAnalytics.setUserData({
                                    userId: String(info.id),
                                    analyticsUserBinding: extractAnalyticsUserBinding(response?.data),
                                    firstName: info.first_name,
                                    lastName: info.last_name,
                                    email: info.email,
                                    phone: info.phone || info.telephone,
                                    latitude: sessionStorage.getItem('_soul_latitude') || undefined,
                                    longitude: sessionStorage.getItem('_soul_longitude') || undefined,
                                });
                            }
                            // Login event: önce soulTrackEvent (backend + dataLayer), fallback gtmUserLogin
                            if (typeof window.soulTrackEvent === 'function') {
                                window.soulTrackEvent({
                                    eventName: 'login',
                                    login_type: 'success',
                                    cd_user_id: String(info.id),
                                });
                            } else if (typeof window.gtmUserLogin === 'function') {
                                window.gtmUserLogin(true, String(info.id));
                            }
                        } else if (typeof window.gtmUserLogin === 'function') {
                            if (typeof window.soulTrackEvent === 'function') {
                                window.soulTrackEvent({
                                    eventName: 'login',
                                    login_type: 'error',
                                    cd_user_id: 'error',
                                });
                            } else {
                                window.gtmUserLogin(false, 'error');
                            }
                        }
                    } catch (err) {
                        // best-effort
                    }

                    if (userRolesId === 3) {
                        Api.updateBasket().then(r => {
                        }).catch((e) => {
                            HelperGeneral.alert(e);
                        });
                        const savedQrcode = localStorage.getItem('qrcode');
                        if (savedQrcode) {
                            Api.transactionAdd({ code: savedQrcode })
                                .then(() => {
                                    localStorage.removeItem('qrcode');
                                    HelperGeneral.alert('Puan kodunuz tanımlanmıştır.', 'success');
                                })
                                .catch((e) => HelperGeneral.alert(e));
                        }
                    }
                    setGlobalSpinner(false);
                } else {
                    HelperGeneral.alert({
                        message: 'Hata',
                        description: 'Giriş bilgileri alınamadı.'
                    });
                    try {
                        if (typeof window.soulTrackEvent === 'function') {
                            window.soulTrackEvent({
                                eventName: 'login',
                                login_type: 'error',
                                cd_user_id: 'error',
                            });
                        } else if (typeof window.gtmUserLogin === 'function') {
                            window.gtmUserLogin(false, 'error');
                        }
                    } catch (err) {
                        // best-effort
                    }
                    setGlobalSpinner(false);
                    return;
                }
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
                try {
                    if (typeof window.soulTrackEvent === 'function') {
                        window.soulTrackEvent({
                            eventName: 'login',
                            login_type: 'error',
                            cd_user_id: 'error',
                        });
                    } else if (typeof window.gtmUserLogin === 'function') {
                        window.gtmUserLogin(false, 'error');
                    }
                } catch (err) {
                    // best-effort
                }
            })
        } else if (step === 2) {
            try {
                let mNumber;
                const uuid = localStorage.getItem('uniqid') ?? HelperGeneral.uuidv4();
                if (e?.mobilePhone !== undefined) {
                    mNumber = e.mobilePhone;
                } else {
                    throw new Error('Bir sorun yaşandı!');
                }

                const data = {
                    telephone: e.mobilePhone,
                    uniqid: uuid,
                    kvkk: true,
                    type: 'remember'
                }

                Api.createContactOtp(data).then(r => {
                    this.setState({
                        info: r?.data,
                        step: 3,
                        customerPhoneNumber: mNumber,
                        date: Date.now() + ((r.data?.expired) * 1000)
                    }, () => {
                        setGlobalSpinner(false);
                    })
                }).catch((e) => {
                    setGlobalSpinner(false);
                    HelperGeneral.alert(e);
                })
            } catch (e) {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
            }
        } else if (step === 3) {
            const data = {
                telephone: customerPhoneNumber,
                code: e?.code,
                send_type: 'sms',
            };
            Api.verifyOtp(data).then(r => {
                this.setState({
                    step: 4,
                    info: r?.data,
                    date: null
                }, () => {
                    setGlobalSpinner(false);
                })
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 4) {
            const data = {
                ...info,
                type: 'remember',
                telephone: customerPhoneNumber,
                new_password: e?.new_password,
                new_password_confirm: e?.new_password_confirm,
            };

            Api.updatePassword(data).then(r => {
                this.setState({
                    step: 1,
                    info: {},
                }, () => {
                    setGlobalSpinner(false);
                    HelperGeneral.alert(trans('t16'), 'success');
                })
            }).catch((e) => {
                setGlobalSpinner(false)
                HelperGeneral.alert(e);
            })
        }
    }

    formatTRPhone = (raw) => {
        // 5055055555
        // 505-505-55-55
        // 05055055555
        // 905055055555
        // +905055055555
        let d = (raw || "").replace(/\D/g, "");

        if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
        if (d.length === 12 && d.startsWith("90")) d = d.slice(2);
        if (d.length > 10) d = d.slice(-10);
        if (d.length !== 10) return "";

        return `(+90)${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
    };

    handlePaste = (e) => {
        e.preventDefault();

        const pasted = e.clipboardData?.getData("text") || "";
        const formatted = this.formatTRPhone(pasted);

        this.form?.current?.setFieldsValue({mobilePhone: formatted});
    };

    render() {
        const {step, width, customerType, date} = this.state;

        let buttonTitle = 'Giriş Yap';
        let help = null;
        if (step === 2) {
            buttonTitle = 'Kod Gönder';
            help = 'Lütfen sisteme kayıtlı telefon numaranızı bu alana girin. Şifrenizi sıfırlamak için SMS ile gönderilen kodu doğrulamanız gerekecektir.';
        } else if (step === 3) {
            buttonTitle = 'Kodu Doğrula';
        } else if (step === 4) {
            buttonTitle = 'Şifreyi Kaydet';
        }

        return (
            <div className={'login-area'} style={width <= 991 ? {backgroundColor: '#FDE5D9'} : {}}>
                <Row className={'w-100 h-100'}>
                    <Col className={'p-0 d-none d-lg-block logo-col'} lg={3} xxl={4}>
                        <LogoScroller className={'logo-div left-side'}/>
                    </Col>
                    <Col className={'p-xl-0 my-auto'} xs={12} lg={6} xxl={4}>
                        <div className={'right'}>
                            <div className={step === 1 ? 'login first-step' : 'login'}>
                                <div className="logo">
                                    <img src={require('../../assets/images/png/theme/SHINIQ_Logo.png')} alt={trans('title')}/>
                                </div>
                                <div className={'form-area'}>
                                    <Form
                                        ref={this.form}
                                        name={'login'}
                                        onFinish={(e) => this.loginSubmit(e)}
                                        layout={'vertical'}
                                    >
                                        {
                                            [1, 2].includes(step) && (
                                                <Form.Item
                                                    name={'mobilePhone'}
                                                    label={"Telefon Numarası"}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Telefon numarası zorunludur",
                                                        },
                                                        {
                                                            validator: (_, value) => {
                                                                if (!value) {
                                                                    return Promise.resolve();
                                                                }

                                                                const digits = String(value).replace(/\D/g, "");

                                                                if (digits.length !== 12) {
                                                                    return Promise.reject(
                                                                        new Error("Telefon numarasını eksiksiz giriniz")
                                                                    );
                                                                }

                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                    extra={step === 2 ? <span className={'mt-2 mb-2 d-flex h-100 w-100'}>{help}</span> : null}
                                                >
                                                    <MaskedInput
                                                        mask={'(\\+90)111-111-11-11'}
                                                        autoComplete={'new-password'}
                                                        type={'tel'}
                                                        onPasteCapture={this.handlePaste}
                                                    />
                                                </Form.Item>
                                            )
                                        }
                                        {
                                            step === 1 && (
                                                <>
                                                    <Form.Item
                                                        label={"Şifre"}
                                                        name={"password"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: trans('t9'),
                                                                min: 8,
                                                            },
                                                        ]}
                                                    >
                                                        <Input.Password autoComplete={'new-password'}/>
                                                    </Form.Item>

                                                    <Form.Item>
                                                        <a
                                                            className={"login-form-forgot"}
                                                            onClick={() => this.setState({step: 2})}
                                                            href="#"
                                                        >
                                                            Şifremi unuttum
                                                        </a>
                                                    </Form.Item>
                                                </>
                                            )
                                        }

                                        {
                                            step === 3 && (
                                                <>
                                                    <div className={'password-reset'}>
                                                        {trans('t3')}
                                                        <span className={'time'}>
                                                            <Countdown
                                                                precision={0}
                                                                renderer={({minutes, seconds}) => (
                                                                    <span>
                                                                        {
                                                                            trans('t2',
                                                                                {
                                                                                    minutes: zeroPad(minutes),
                                                                                    seconds: zeroPad(seconds),
                                                                                }
                                                                            )
                                                                        }
                                                                    </span>
                                                                )}
                                                                onComplete={() => this.setState(
                                                                    {
                                                                        step: (step - 1),
                                                                        date: null
                                                                    }, () => {
                                                                        if (step === 3) {
                                                                            HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                                                        }
                                                                    })
                                                                }
                                                                date={date}
                                                            />
                                                        </span>
                                                    </div>
                                                    <Form.Item
                                                        name={'code'}
                                                        rules={[
                                                            () => ({
                                                                validator(_, value) {
                                                                    const v = HelperGeneral.telephoneClear(value)
                                                                    if (v.length === 5) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(
                                                                        new Error(trans('login.t22'))
                                                                    )
                                                                },
                                                            })]}
                                                        help={'Telefonunuza gönderilen 5 haneli onay kodunu giriniz.'}
                                                    >
                                                        <MaskedInput
                                                            mask={'11111'}
                                                            autoComplete={'new-password'}
                                                            size={5}
                                                        />
                                                    </Form.Item>
                                                </>
                                            )
                                        }

                                        {
                                            step === 4 && (
                                                <>
                                                    <Form.Item
                                                        name={"new_password"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: trans('t14'),
                                                                min: 8,
                                                            },
                                                        ]}
                                                        label={trans('t11')}
                                                    >
                                                        <Input.Password autoComplete={'new-password'}/>
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={"new_password_confirm"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: trans('t15'),
                                                                min: 8,
                                                            },
                                                            ({getFieldValue}) => ({
                                                                validator(_, value) {
                                                                    if (!value || getFieldValue('new_password') === value) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(
                                                                        new Error(trans('t13'))
                                                                    )
                                                                },
                                                            }),
                                                        ]}
                                                        label={trans('t12')}
                                                    >
                                                        <Input.Password autoComplete={'new-password'}/>
                                                    </Form.Item>
                                                </>
                                            )
                                        }

                                        <Container className={'p-0'}>
                                            <Row>
                                                {
                                                    step === 1 && customerType.includes(3) && (
                                                        <Col xs={6} className={'button-col'}>
                                                            <Link to={'/uye-ol'}>
                                                                <Button className={"login-form-button register-button"}>
                                                                    <span>Tüketici Ol</span>
                                                                </Button>
                                                            </Link>
                                                        </Col>
                                                    )
                                                }
                                                <Col xs={(step === 1 && customerType.includes(3)) ? 6 : 12} className={'button-col'}>
                                                    <Form.Item className={'m-0'}>
                                                        <Button
                                                            type={"primary"}
                                                            htmlType={"submit"}
                                                            className={"login-form-button"}
                                                        >
                                                            {buttonTitle}
                                                        </Button>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Container>

                                        {
                                            step === 2 && (
                                                <Form.Item className={'m-0'}>
                                                    <div className={'back-button mt-3'}>
                                                        <div>veya</div>
                                                        <div onClick={() => this.setState({step: 1})}>
                                                            Giriş Sayfasına Dönmek için Tıklayın
                                                        </div>
                                                    </div>
                                                </Form.Item>
                                            )
                                        }
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className={'p-0 d-none d-lg-block logo-col'} lg={3} xxl={4}>
                        <LogoScroller className={'logo-div right-side'}/>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouter(Login);
